import { cn } from '@/utils/tailwind-util';
import React, { useRef } from 'react';

interface Props {
  label: React.ReactNode;
  children: React.ReactNode | null;
  size?: 'sm' | 'md';
  styles?: string;
  className?: string;
}

const getSize = (size) => {
  if (size === 'sx') {
    return 'px-1 py-2 text-[13px] bg-gray-300 text-gray-900';
  }

  return 'p-[14px] text-sm bg-primary text-white font-semibold';
};

const Tooltip: React.FC<Props> = ({
  label,
  children,
  size = 'md',
  styles,
  className,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const onMouseOver = () => {
    if (children && contentRef?.current) {
      contentRef.current.style.visibility = 'visible';
    }
  };

  const onMouseLeave = () => {
    if (children && contentRef?.current) {
      contentRef.current.style.visibility = 'hidden';
    }
  };

  return (
    <div className={cn('relative inline-block', className)}>
      <div
        className="cursor-pointer"
        onMouseOver={onMouseOver}
        onFocus={onMouseOver}
        onMouseLeave={onMouseLeave}
      >
        {label}
      </div>
      <div
        ref={contentRef}
        className={cn(
          'absolute left-2% top-94% whitespace-nowrap rounded-[4px] z-50 hidden',
          getSize(size),
          styles
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default Tooltip;
